import { Icon, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React, { useCallback } from 'react';
import { Pressable } from 'react-native';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { useWithValueVisibility } from '../../../../../../../hooks/useWithValueVisibility';
import { getFlex } from '../utils';

import { InvestmentStrategyItemTypes } from './types';

export const InvestmentStrategyItemDesktop: React.FC<InvestmentStrategyItemTypes.Props> = ({
  item,
}) => {
  const withValueVisibility = useWithValueVisibility();
  const [expanded, setExpanded] = React.useState(false);

  const toggleExpand = useCallback(() => {
    setExpanded((state) => !state);
  }, []);

  return (
    <TableContent
      direction="row"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}
      flexWrap="wrap">
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText fontWeight="bold">Data</TableContentItemText>
        <TableContentItemText>
          {withValueVisibility(item.positionDateNormalized)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText fontWeight="bold">Cliente</TableContentItemText>
        <TableContentItemText>
          {withValueVisibility(item.customerNameNormalized)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText fontWeight="bold">Conta de custódia</TableContentItemText>
        <TableContentItemText>
          {withValueVisibility(item.customerCustodyAccountNumberNormalized)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText fontWeight="bold">Conta sinacor</TableContentItemText>
        <TableContentItemText>
          {withValueVisibility(item.customerAccountNumber)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText fontWeight="bold">CPF/CNPJ</TableContentItemText>
        <TableContentItemText>
          {withValueVisibility(item.customerCpfOrCnpjNormalized)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText fontWeight="bold">Nome do assessor</TableContentItemText>
        <TableContentItemText>
          {withValueVisibility(item.advisorNameNormalized)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText fontWeight="bold">Filial</TableContentItemText>
        <TableContentItemText>
          {withValueVisibility(item.branchNameNormalized)}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex="none">
        <Pressable onPress={toggleExpand}>
          <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size="xs" />
        </Pressable>
      </TableContentItemColumn>

      {expanded && (
        <HStack
          marginTop={Spacing['inline.xxxs']}
          width="100%"
          backgroundColor={Color.background}
          padding={Spacing['inset.xs']}>
          <TableContentItemColumn flex={getFlex(7)}>
            <TableContentItemText fontWeight="bold">Produto</TableContentItemText>
            <TableContentItemText>
              {withValueVisibility(item.productNameNormalized)}
            </TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFlex(8)}>
            <TableContentItemText fontWeight="bold">Classe</TableContentItemText>
            <TableContentItemText>
              {withValueVisibility(item.productClassNormalized)}
            </TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFlex(9)}>
            <TableContentItemText fontWeight="bold">Quantidade</TableContentItemText>
            <TableContentItemText>{withValueVisibility(item.quantity)}</TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFlex(10)}>
            <TableContentItemText fontWeight="bold">Valor PU</TableContentItemText>
            <TableContentItemText>
              {withValueVisibility(item.unitPriceNormalized)}
            </TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFlex(11)}>
            <TableContentItemText fontWeight="bold">Data PU</TableContentItemText>
            <TableContentItemText>
              {withValueVisibility(item.positionDateNormalized)}
            </TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn flex={getFlex(12)}>
            <TableContentItemText fontWeight="bold">Valor produto</TableContentItemText>
            <TableContentItemText>
              {withValueVisibility(item.positionValueNormalized)}
            </TableContentItemText>
          </TableContentItemColumn>
        </HStack>
      )}
    </TableContent>
  );
};
